__webpack_require__.p = "/CTU-TimeTable-Generator/_next/";